/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs */

const en_admin_external_booking_edit_invoice_status_not_paid = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not paid`)
};

const de_admin_external_booking_edit_invoice_status_not_paid = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nicht bezahlt`)
};

const es_admin_external_booking_edit_invoice_status_not_paid = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no pagada`)
};

const fr_admin_external_booking_edit_invoice_status_not_paid = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non payée`)
};

const nl_admin_external_booking_edit_invoice_status_not_paid = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`niet betaald`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */
const it_admin_external_booking_edit_invoice_status_not_paid = en_admin_external_booking_edit_invoice_status_not_paid;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_invoice_status_not_paid = en_admin_external_booking_edit_invoice_status_not_paid;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */
const pl_admin_external_booking_edit_invoice_status_not_paid = en_admin_external_booking_edit_invoice_status_not_paid;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */
const hu_admin_external_booking_edit_invoice_status_not_paid = en_admin_external_booking_edit_invoice_status_not_paid;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs) => LocalizedString} */
const ro_admin_external_booking_edit_invoice_status_not_paid = en_admin_external_booking_edit_invoice_status_not_paid;

/**
* | output |
* | --- |
* | "not paid" |
*
* @param {Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_invoice_status_not_paid = /** @type {((inputs?: Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Invoice_Status_Not_PaidInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "de") return de_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "es") return es_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "it") return it_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_invoice_status_not_paid(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_invoice_status_not_paid(inputs)
	return ro_admin_external_booking_edit_invoice_status_not_paid(inputs)
});
export { admin_external_booking_edit_invoice_status_not_paid as "admin.external_booking_edit.invoice_status_not_paid" }